// src/components/FD/FDHome.js
import React, { useEffect } from "react";
import { Routes, Route, NavLink, useLocation, useNavigate } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import ApplicationRegistration from "./ApplicationRegistration";
import PaymentReceiver from "./PaymentReceiver";
import TransactionHistory from "./TransactionHistory";
import LuckyDraw from "./LuckyDraw";
import CloseAccount from "./CloseAccount";

const FDHome = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const normalizedPath = location.pathname.replace(/\/+$/, "");
  const showSidebar = normalizedPath === "/fd";

  // Keyboard shortcut for total amount (Ctrl+Q)
  useEffect(() => {
    const handleKeyPress = async (e) => {
      if (e.ctrlKey && e.key === 'q') {
        e.preventDefault();
        try {
          const response = await axios.get(`${API_BASE_URL}/api/fd/total-amount`);
          const total = response.data.total_amount;
          alert(`Total Amount Collected: ₹${total.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
        } catch (error) {
          console.error('Error fetching total amount:', error);
          alert('Failed to fetch total amount');
        }
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  return (
    <div className={`dashboard-container${showSidebar ? "" : " no-sidebar"}`}>
      <style>
        {`
          /* General Page Styling */
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }

          html, body {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            font-family: 'Poppins', sans-serif;
            background: white;
            height: auto;
            min-height: 100vh;
            overflow-y: auto;
          }

          .dashboard-container {
            display: flex;
            width: 100%;
            max-width: 100%;
            min-height: 100vh;
            height: auto;
            background-color: white;
            border-radius: 0;
            box-shadow: none;
            overflow-y: auto;
          }

          .no-sidebar {
            width: 100%;
            max-width: 100%;
          }

          .sidebar {
            width: 280px;
            background: #2c3e50;
            color: white;
            padding: 20px;
            display: flex;
            flex-direction: column;
          }

          .sidebar nav ul {
            list-style: none;
            padding: 0;
          }

          .sidebar h2 {
            text-align: center;
            font-size: 24px;
            font-weight: bold;
            padding-bottom: 15px;
            border-bottom: 2px solid #34495e;
          }

          .sidebar nav ul li {
            margin: 15px 0;
          }

          .sidebar nav ul li a {
            text-decoration: none;
            color: white;
            font-size: 16px;
            font-weight: 500;
            display: flex;
            align-items: center;
            padding: 10px;
            border-radius: 6px;
            transition: all 0.3s ease-in-out;
          }

          .sidebar nav ul li a:hover,
          .sidebar nav ul li a.active-link {
            background-color: #34495e;
            transform: scale(1.05);
          }

          .sidebar nav ul li a i {
            margin-right: 10px;
          }

          .back-button {
            width: 100%;
            padding: 10px;
            background: #c0392b;
            color: white;
            font-size: 16px;
            font-weight: bold;
            border: none;
            cursor: pointer;
            border-radius: 6px;
            transition: all 0.3s ease-in-out;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .back-button i {
            margin-right: 8px;
          }

          .back-button:hover {
            background: #a93226;
            transform: scale(1.05);
          }

          .content {
            flex: 1;
            padding: 30px;
            background: #fdfdfd;
            text-align: center;
            overflow-y: auto;
          }

          .content--full {
            padding: 0;
            background: transparent;
            text-align: left;
          }

          .content-back-container {
            display: flex;
            justify-content: flex-start;
            margin-bottom: 20px;
          }

          .content-back-button {
            padding: 10px 18px;
            background: #2c3e50;
            color: white;
            border: none;
            border-radius: 6px;
            font-size: 16px;
            font-weight: 500;
            display: inline-flex;
            align-items: center;
            gap: 8px;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
          }

          .content-back-button i {
            margin-right: 0;
          }

          .content-back-button:hover {
            background: #34495e;
            transform: translateY(-1px);
          }

          .content h2 {
            font-size: 24px;
            margin-bottom: 15px;
            color: #2c3e50;
          }

          .content p {
            font-size: 16px;
            color: #555;
          }

          @media screen and (max-width: 768px) {
            .dashboard-container {
              flex-direction: column;
              height: auto;
            }

            .sidebar {
              width: 100%;
              padding: 15px;
              text-align: center;
            }

            .sidebar nav ul li {
              margin: 10px 0;
            }

            .back-button {
              width: 80%;
              margin: auto;
            }
          }
        `}
      </style>

      {showSidebar && (
        <aside className="sidebar">
          <h2>RD Component</h2>
          <nav>
            <ul>
              <li>
                <NavLink to="application-registration" className={({ isActive }) => (isActive ? "active-link" : undefined)}>
                  <i className="fas fa-file-alt"></i> Application Registration
                </NavLink>
              </li>
              <li>
                <NavLink to="payment-receiver" className={({ isActive }) => (isActive ? "active-link" : undefined)}>
                  <i className="fas fa-money-check-alt"></i> Payment Receiver
                </NavLink>
              </li>
              <li>
                <NavLink to="transaction-history" className={({ isActive }) => (isActive ? "active-link" : undefined)}>
                  <i className="fas fa-history"></i> Transaction History
                </NavLink>
              </li>
              <li>
                <NavLink to="lucky-draw" className={({ isActive }) => (isActive ? "active-link" : undefined)}>
                  <i className="fas fa-trophy"></i> Lucky Draw
                </NavLink>
              </li>
              <li>
                <NavLink to="close-account" className={({ isActive }) => (isActive ? "active-link" : undefined)}>
                  <i className="fas fa-times-circle"></i> Close Account
                </NavLink>
              </li>
              <li>
                <button onClick={() => navigate("/admin-dashboard")} className="back-button">
                  <i className="fas fa-arrow-left"></i> Back
                </button>
              </li>
            </ul>
          </nav>
        </aside>
      )}
      <main className={showSidebar ? "content" : "content content--full"}>
        {!showSidebar && (
          <div className="content-back-container">
            <button
              type="button"
              className="content-back-button"
              onClick={() => navigate("/fd")}
            >
              <i className="fas fa-arrow-left"></i>
              Back to RD Menu
            </button>
          </div>
        )}
        <Routes>
          <Route index element={
            <div>
              <h2>Welcome to the RD Component</h2>
              <p>Select an option from the menu to proceed.</p>
              <p style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
                Press <strong>Ctrl+Q</strong> to view total amount collected
              </p>
            </div>
          } />
          <Route path="application-registration" element={<ApplicationRegistration />} />
          <Route path="payment-receiver" element={<PaymentReceiver />} />
          <Route path="transaction-history" element={<TransactionHistory />} />
          <Route path="lucky-draw" element={<LuckyDraw />} />
          <Route path="close-account" element={<CloseAccount />} />
          <Route path="*" element={
            <div>
              <h2>Welcome to the RD Component</h2>
              <p>Select an option from the menu to proceed.</p>
            </div>
          } />
        </Routes>
      </main>
    </div>
  );
};

export default FDHome;

